<template>
  <div>
    <div class="profile-details">
      <div class="row profile-user__row-desc">
        <div class="col">
          <div class="profile-user__name">
            {{ profile.name }} <span>{{ profile.age }} </span>
            <div class="dot-online"></div>
          </div>
          <div class="profile-user__loc">
            {{ profile.regular_address }}
            <div class="loc__dis">
              <i class="demo-icon icon-pin"></i>{{ profile.location.distance }}<span>km</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row profile-user__row-veryfication p-un mt-1" v-if="profile.verified_at">
        <p class="verification-desc verification-desc--positive pl-3">{{ trans.get('profile:show.profile_verified_by_photo') }}</p>
      </div>
      <div class="profile-user__about" v-if="profile.description">
        <section>
          <h4 class="mb-2">{{ trans.get('profile:show.about_me_header') }}</h4>
          <p style="white-space: pre-line">{{ profile.description }}</p>
        </section>
      </div>

      <div class="profile-user__statuses" v-if="profile.attributes.has_any">
        <h4>{{ trans.get('profile:show.my_statuses_header') }}</h4>
        <div class="box-status">
          <div class="box-attributes" v-if="profile.attributes.relationship">
            <div class="box-attributes__attr"><i class="demo-icon icon-n-heart"></i><span>{{ trans.get('profile:show.info.relationship') }} </span>
            </div>
            <div class="box-attributes__set"> {{ profile.attributes.relationship_text }}</div>
          </div>
          <div class="box-attributes" v-if="profile.attributes.has_children">
            <div class="box-attributes__attr"><i class="demo-icon icon-n-child"></i><span>{{ trans.get('profile:show.info.children') }} </span></div>
            <div class="box-attributes__set">{{ profile.attributes.has_children_text }}</div>
          </div>
          <div class="box-attributes" v-if="profile.attributes.living">
            <div class="box-attributes__attr"><i class="demo-icon icon-n-home"></i><span>{{ trans.get('profile:show.info.living') }} </span></div>
            <div class="box-attributes__set">{{ profile.attributes.living_text }}</div>
          </div>
          <div class="box-attributes" v-if="profile.attributes.smoker">
            <div class="box-attributes__attr"><i class="demo-icon icon-n-smoker"></i><span>{{ trans.get('profile:show.info.smoker') }}</span></div>
            <div class="box-attributes__set">{{ profile.attributes.smoker_text }}</div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <ReportModalButton :profileId="profile.id"></ReportModalButton>
      </div>
    </div>

    <div class="profile-details__space"></div>
  </div>
</template>

<script>

import ReportModalButton from '../../modules/ReportModalButton';

export default {
  name: 'ProfileDetails',
  components: { ReportModalButton },
  props: {
    profile: Object,
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {
  }
};
</script>


